import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter, locationShape, browserHistory } from 'react-router';

import TokenStore from '../stores/TokenStore';
import ProfileStore from '../stores/ProfileStore';
import CurrentUserIdStore from '../stores/CurrentUserIdStore';
import AuthActions from '../actions/AuthActions';

export const NEXT_PATH_STORAGE_KEY = 'nextPath';

function getState() {
  return {
    profile: ProfileStore.getState(),
    currentUser: CurrentUserIdStore.getState(),
  };
}

class App extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    location: locationShape,
  }

  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (TokenStore.isAuthenticated()) {
      const nextPath = localStorage.getItem(NEXT_PATH_STORAGE_KEY);
      localStorage.removeItem(NEXT_PATH_STORAGE_KEY);
      if (nextPath) {
        browserHistory.push(nextPath);
      }
    } else {
      localStorage.setItem(NEXT_PATH_STORAGE_KEY, this.props.location.pathname);
      browserHistory.push('login');
    }
  }

  componentDidMount() {
    this.profileSubscription = ProfileStore.addListener(this._onChange);
    this.currentUserSubscription = CurrentUserIdStore.addListener(this._onChange);
    if (TokenStore.isAuthenticated()) {
      AuthActions.loadUserInfo();
    }
  }

  componentWillUnmount() {
    this.profileSubscription.remove();
    this.currentUserSubscription.remove();
  }

  _onChange() {
    this.setState(getState());
  }

  render() {
    return (<div>
      { this.state.currentUser && this.props.children }
    </div>);
  }
}

export default withRouter(App);
